import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* 404 */}
        <div className="relative mb-8">
          <h1 className="text-[180px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500 animate-pulse">
            404
          </h1>

          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-64 h-64 bg-blue-500/20 rounded-full blur-3xl animate-ping"></div>
          </div>
        </div>

        {/* Animated Icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-blue-500/20 blur-xl animate-pulse"></div>
            <div className="relative w-24 h-24 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center animate-bounce">
              <span className="text-5xl">🔍</span>
            </div>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-4xl font-bold text-white mb-4">
          Page Not Found
        </h2>

        <p className="text-xl text-gray-300 mb-8">
          Sorry, the page you're looking for doesn't exist, has been moved,
          or the URL may be incorrect.
        </p>

        {/* Info Cards */}
        <div className="grid grid-cols-3 gap-4 mb-10 max-w-md mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4 border border-white/20">
            <div className="text-2xl font-bold text-blue-400">404</div>
            <div className="text-sm text-gray-400">Status Code</div>
          </div>

          <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4 border border-white/20">
            <div className="text-2xl font-bold text-purple-400">0</div>
            <div className="text-sm text-gray-400">Results Found</div>
          </div>

          <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4 border border-white/20">
            <div className="text-2xl font-bold text-pink-400">∞</div>
            <div className="text-sm text-gray-400">Ways Back</div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => navigate('/')}
            size="lg"
            variant="primary"
          >
            🏠 Go Home
          </Button>

          <Button
            onClick={() => navigate(-1)}
            size="lg"
            variant="outline"
            className="text-white border-white hover:bg-white/10"
          >
            ← Go Back
          </Button>
        </div>

        {/* Footer Quote */}
        <p className="mt-12 text-gray-500 italic">
          "Every wrong turn is a chance to find the right path."
        </p>
      </div>
    </div>
  );
};